module.exports = __webpack_public_path__ + "icon-pt.46082a682919bc380ff8.png";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/ucla-prrla/ucla-prrla/ucla-prrla/src/assets/img/icon-pt.png
// module id = ../../../../../src/assets/img/icon-pt.png
// module chunks = 2